import proactiveMessageAlert from "./assets/proactiveMessageAlert.wav";

export function triggerProactiveSound(isProactiveEnabled: boolean) {
    const isMuted = localStorage.getItem("is-proactive-sound-muted") === "true";
    if (isProactiveEnabled && !isMuted) {
        void new Audio(proactiveMessageAlert).play();
    }
}
